import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-editar-perfil',
  templateUrl: './dialog-editar-perfil.component.html',
  styleUrls: ['./dialog-editar-perfil.component.scss']
})
export class DialogEditarPerfilComponent implements OnInit {
  formulario: FormGroup;
  constructor(
    public dialogRef: MatDialogRef<DialogEditarPerfilComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder) { }

  ngOnInit(): void {
    this.initForm()
  }

  initForm() {
    this.formulario = this.fb.group({
        email: [, { validators: [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$") 
    ]}]});
  }

  get email() {
    return this.formulario.get("email");
  }

}
